import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { ColumnDef } from '@tanstack/react-table'
import { LocationJson } from 'app/types/entities'
import { logError } from 'lib/logging'
import { gqlFetchList } from 'app/lib/graphqlClient'

export type SettingsAvailabilityData = {
  locations: { hits: LocationJson[]; total: number }
}

export type UseSettingsAvailabilityReturn = {
  locations: { hits: LocationJson[]; total: number }
  columns: ColumnDef<LocationJson, any>[]
  loading: boolean
}

export function useSettingsAvailability(): UseSettingsAvailabilityReturn {
  const [data, setData] = useState<SettingsAvailabilityData>({ locations: { hits: [], total: 0 } })
  const [loading, setLoading] = useState(true)
  const [searchParams] = useSearchParams()
  const columns = defaultColumns()

  useEffect(() => {
    const sort = searchParams.get(`sort`)
    const query = searchParams.get(`query`)
    const page = searchParams.get(`page`)
    const sortParts = sort?.split(`:`)
    gqlFetchList<LocationJson>(
      'locations',
      {
        search: query || undefined,
        pagination: page ? { page: Number(page) } : undefined,
        sort: sortParts?.length === 2 ? { field: sortParts[0], direction: sortParts[1] } : undefined,
      },
      'id name products',
    )
      .then((d) => setData({ locations: { hits: d.hits, total: d.total } }))
      .catch((err) => logError(`Error fetching availability locations`, err))
      .finally(() => setLoading(false))
  }, [searchParams])

  return { locations: data.locations, columns, loading }
}

function defaultColumns(): ColumnDef<LocationJson, any>[] {
  return [
    {
      id: `Location Name`,
      accessorKey: `name`,
      header: `Location Name`,
      meta: {
        defaultVisible: true,
        pinned: true,
        sortKey: `name.keyword`,
      },
    },
    {
      id: `Scheduler`,
      header: `Scheduler`,
      meta: { defaultVisible: true },
      enableSorting: false,
    },
    {
      id: `AI Agent`,
      header: `AI Agent`,
      meta: { defaultVisible: true },
      enableSorting: false,
    },
  ]
}
